import React, { useState } from "react";
import {
  Typography,
  Card,
  CardBody,
  Button,
  Input,
} from "@material-tailwind/react";

declare global {
  interface Window {
    fbq: any;
  }
}

export const trackEvent = (event: string, data: any) => {
  if (typeof window !== "undefined") {
    window.fbq("track", event, data);
  }
};

export default function Subscribe() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    setError("");
    setMessage("");

    try {
      const res = await fetch("/api/subscribe-brevo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ EMAIL: email }),
      });

      const data = await res.json();
      if (res.ok) {
        setMessage(data.message);
        trackEvent("Subscribe", {
          content_name: `Newsletter Subscription`,
          content_category: "Newsletter",
          content_ids: [`newsletter_subscription`],
          content_type: "form",
        });
      } else {
        setError(data.message || "An error occurred. Please try again.");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <Card shadow={true} className="relative overflow-hidden">
      <CardBody className="pt-6 px-6 pb-0">
        <div className="relative z-10">
          <Typography
            variant="h6"
            color="blue-gray"
            className="mb-4 capitalize"
          >
            Join our community!
          </Typography>
          <div id="sib-form-container">
            <div id="sib-container">
              <form id="sib-form" onSubmit={handleSubmit}>
                <div className="block">
                  <div className="sib-input sib-form-block px-0">
                    <div className="form__entry entry_block">
                      <div className="form__label-row ">
                        <div className="entry__field">
                          <Input
                            type="text"
                            id="EMAIL"
                            name="EMAIL"
                            autoComplete="off"
                            data-required="true"
                            required
                            label="Email"
                            className="input w-full"
                            color="gray"
                            defaultValue=""
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          <label
                            className="entry__error entry__error--primary"
                            style={{
                              fontSize: "16px",
                              textAlign: "left",
                              fontFamily: "&quot;Helvetica&quot;, sans-serif",
                              color: "#661d1d",
                              backgroundColor: "#ffeded",
                              borderRadius: "3px",
                              borderColor: "#ff4949",
                            }}
                          ></label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="sib-form-block px-0">
                    <Button
                      className="w-full mt-4 sib-form-block__button sib-form-block__button-with-loader font-medium capitalize"
                      form="sib-form"
                      type="submit"
                    >
                      Subscribe
                    </Button>
                  </div>
                </div>
                <input
                  type="text"
                  name="email_address_check"
                  value=""
                  className="input--hidden"
                />
                <input type="hidden" name="locale" value="en" />
                <input type="hidden" name="html_type" value="simple" />
                {message && (
                  <div
                    id="success-message"
                    className="mt-3 text-sm text-green-500"
                  >
                    Thank You! {message}
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
